import React, { type FC } from 'react'

import dayjs from 'dayjs'

type StartTimeInfoProps = {
  startTime?: string | number
  isFuture?: boolean
}

export const StartTimeInfo: FC<StartTimeInfoProps> = ({
  startTime = 0,
  isFuture = false
}) => {
  const date = dayjs.unix(+startTime)

  const formattedDate = date.format('ddd, DD MMM')

  const formattedTime = date.format('HH:mm')

  return (
    <>
      {isFuture ? (
        <>
          <div>{formattedDate}</div>
          <div>{formattedTime}</div>
        </>
      ) : (
        <div>{`${formattedDate} | ${formattedTime}`}</div>
      )}
    </>
  )
}
